// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I2ysv","input":"styles_input__3rhS_"};